import type { HelpFile } from '../../types/help'
import { AccessProfileFormTestIds } from '../../../testids/AccessProfileFormTestIds'

export const accessProfileFormHelp: HelpFile = {
  docPage: '/docs/governance/access-profiles',
  texts: {
    [AccessProfileFormTestIds.selectRiskLevel]: 'Risk level of this access profile. Drives the approval policy and certification frequency — high-risk profiles typically need stricter review.',
    [AccessProfileFormTestIds.selectReviewFrequency]: 'How often this profile must be re-certified. Pick a cadence that matches the sensitivity of the access it grants.',
    [AccessProfileFormTestIds.btnCancel]: null,
    [AccessProfileFormTestIds.btnSubmit]: null,
  },
}
